import Vue from 'vue'
import VueResource from 'vue-resource'
import App from './App.vue'
import router from './router'
import store from './store'
import Maps from './maps'
import './events'

import { addGoogleMaps } from './utils'
import { VueHammer } from 'vue2-hammer'

Vue.config.productionTip = true

Vue.prototype.$headers = {
  'Authorization': 'Basic YXBwOlBhdzcgZ3NpZCBpeFBTIGsyMTAgTVZESSBpdzVW'
}

Vue.use(VueResource)

Vue.use(VueHammer)

VueHammer.config = {
  swipe: {
    direction: 'horizontal'
  }
}

Vue.prototype.$mobile = ((window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) < 1025)

Vue.prototype.$googleMaps = addGoogleMaps(Maps.apiKey)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
